import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

// Shown in place of the welcome message while the chat is empty: Aura's 3D bolt and one question.
// The bolt is served from public/aura-bolt.svg; if that file is missing, only the headline shows.
const MASCOT_SRC = `${process.env.PUBLIC_URL || ''}/aura-bolt.svg`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
`;

const Wrap = styled.div`
  flex: 1;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px 16px;
  text-align: center;
`;

const Mascot = styled.img`
  width: 140px;
  height: auto;
  user-select: none;
  animation: ${float} 3.2s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Headline = styled.h2`
  margin: 0;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: -0.01em;
`;

const WelcomeHero = () => {
  const [showMascot, setShowMascot] = useState(true);
  return (
    <Wrap>
      {showMascot && (
        <Mascot src={MASCOT_SRC} alt="" aria-hidden="true" draggable="false" onError={() => setShowMascot(false)} />
      )}
      <Headline>How can I help you today?</Headline>
    </Wrap>
  );
};

export default WelcomeHero;
